import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap, concatMap } from 'rxjs/operators';
import { ReportsService } from '../../../services/http/reports.service';
import { performanceDataError } from '../../performance/actions/performance.actions';
import { ReportRequestActions } from '../action-types';
import { reportRequesteDataLoaded, reportRequesteDataLoadedError } from '../actions/report-request.actions';

@Injectable()
export class ReportRequestEffects {

    loadReportRequestData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ReportRequestActions.loadReportRequestData),
            switchMap((action) =>
                this.reportService
                    .getReportRequestData()
                    .pipe(
                        map((data) => reportRequesteDataLoaded({ payload: data })),
                        catchError(() => {
                            const errorMessage =
                                "Unfortunately Report request data couldn't be loaded. Apologies for the inconvenience.";
                            return of(reportRequesteDataLoadedError({ errorMessage }));
                        })
                    )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private reportService: ReportsService
    ) { }
}
